if (process.env.NODE_ENV === 'production') {
  module.exports = require('./tools.prod');
} else {
  module.exports = require('./tools.dev');
}
